import { Stack, Typography } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { UploadDetail } from '../../../../services/entities/impl/blfApi/schemas/uploadSummary';
import { CollectionDetailsNavButton } from '../../../collections/components/CollectionDetailsNavButton';
import { DiagnosticFeature } from '../../../commonUI/viewMode/DiagnosticFeature';
import { CollectionDebugLauncher } from '../../../debugInfo/collections/CollectionDebugLauncher';
import { UploadStatus } from './UploadStatus/UploadStatus';

export const UploadDetailListItem = ({
  uploadDetail,
}: {
  uploadDetail: UploadDetail;
}) => {
  const formattedDate = format(parseISO(uploadDetail.collectionDate), 'M/dd');

  return (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Typography
        sx={(theme) => ({
          fontSize: '0.875rem',
          fontWeight: 400,
          color:
            uploadDetail.status === 'Completed'
              ? theme.vars.palette.text.secondary
              : theme.vars.palette.text.primary,
        })}
      >
        {formattedDate} - {uploadDetail.cameraID}
      </Typography>
      <Stack direction='row' spacing={1} sx={{ alignItems: 'center' }}>
        <UploadStatus
          status={uploadDetail.status}
          progress={uploadDetail.percentUploaded}
        />
        <DiagnosticFeature>
          <CollectionDetailsNavButton
            collectionId={uploadDetail.collectionID}
            iconButtonSx={{ p: 0 }}
          />
          <CollectionDebugLauncher
            collectionId={uploadDetail.collectionID}
            uploadDetail={uploadDetail}
          />
        </DiagnosticFeature>
      </Stack>
    </Stack>
  );
};
